<div class="SLV2-completion-pg-wrap">

    <!-- header start -->
    <div class="SLV2-completion-hdr">
        <div class="SLV2-completion-hdr-title-row">
            <button class="SLV2-completion-close-btn" (click)="navigateToChapterPractice()">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
            </button>
        </div>
    </div>
    <!-- header ended -->

    <!-- question box start -->
    <div class="SLV2-completion-body-wrap">
        <div class="SLV2-completion-box">
        <div class="SLV2-completion-body-wrap">
            <div class="SLV2-completion-box">
                <h3 class="SLV2-completion-hdng">{{getTopicName()}} !</h3>
                    <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" class="SLV2-champion-icon" />
                    <h4 class="SLV2-champion-gritting-title">Well done!</h4>
                </div>
            </div>
            
            <!-- question box ended -->

            <div class="SLV2-yellow-box" *ngIf="disableNextTopic == false">
                <h5 class="SLV2-yellow-title">Next topic</h5>
                <div class="SLV2-yellow-bold-text">{{getTopic()[0].topicName}}</div>
                <button class="SLV2-completion-text-btn sm" (click)="goToNextTopic()">Start now <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" class="right" /></button>
            </div>

            <div class="SLV2-completion-actn-area"> 
                <button class="SLV2-completion-solid-btn" *ngIf="disableNextTopic != false" (click)="goToReviseModule()">Continue Learning</button>
                <!-- <button class="SLV2-completion-text-btn">View solutions</button> -->
             </div>
        </div>
    </div>


</div>